import { jenisKegiatanAxiosDelete } from "../../../../Utils/axiosFunctions";
import DataTableTitle from "../../../DataTableComponents/DataTableTitle";
import DeleteModal from "../../functions/DeleteModal";
import JenisKegiatanModal from "../components/JenisKegiatanModal";

const JenisKegiatanColumns = (resetState) => [
  {
    name: <DataTableTitle text={"Id Jenis Kegiatan"} />,
    width: "15%",
    selector: (row) => row.pk,
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Nama Jenis Kegiatan"} />,
    selector: (row) => row.nama_jenis_kegiatan,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Operasi"} />,
    width: "15%",
    cell: (row) => (
      <div>
        <JenisKegiatanModal
          create={false}
          jkg={row}
          resetState={() => resetState()}
        />
        &nbsp;&nbsp;
        <DeleteModal
          name={"jenis kegiatan"}
          axiosDelete={jenisKegiatanAxiosDelete}
          pk={row.pk}
          resetState={resetState}
        />
      </div>
    ),
  },
];

export default JenisKegiatanColumns;
